import axios from "axios";
import BoxComponent from "Common/Components/BoxComponent/BoxComponent";
import { getUsername } from "Common/Components/getRoleId";
import InvoiceWithInput from "Common/Components/PDFRender";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

function UserDashboard() {
  const [reportData, setReportData] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [UserFullName, setUserFullName] = useState<boolean>(true);
  const token = localStorage?.getItem("app_atkey");
  const [DataSeed, setDataSeed] = useState<any>([]);
  const [Dataesticide, setDataesticide] = useState<any>([]);
  const [LoadFarmer, setLoadFarmer] = useState<any>([]);
  const [pamentFarmerr, setpamentFarmerr] = useState<any>([]);
  const [userinfoData, setuserinfoData] = useState<any>();
  const getuserID = Number(getUsername(localStorage.getItem("app_atkey")));
  useEffect(() => {
    const fetchReport = async () => {
      try {
        const cropID = Number(localStorage.getItem("crop_year_id"));
        const cropYearQuery = `?crop_year_id=${cropID}`;
        const response = await axios.get<any>(
          `https://api.havirkesht.ir/users-dashboard/?crop_year_id=${cropID}&user_id=${getuserID}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
            },
          }
        );
        const getseedFarmer = await axios.get(
          `https://api.havirkesht.ir/farmers-seed/by-user/${getuserID}${cropYearQuery}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
            },
          }
        );
        const response3 = await axios.get(
          `https://api.havirkesht.ir/commitment/by-user/${getuserID}${cropYearQuery}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const userallinfos = await axios.get(
          `https://api.havirkesht.ir/users/${getuserID}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setuserinfoData(userallinfos.data);
        setUserFullName(response3.data[0]);

        const getposionFarmer = await axios.get(
          `https://api.havirkesht.ir/farmers-pesticide/by-user/${getuserID}${cropYearQuery}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
            },
          }
        );
        const getLoadFarmer = await axios.get(
          `https://api.havirkesht.ir/farmers_load/by-user/${getuserID}${cropYearQuery}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
            },
          }
        );

        const getPamentData = await axios.get(
          `https://api.havirkesht.ir/farmers_payment/by-user/${getuserID}${cropYearQuery}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
            },
          }
        );
        setDataSeed(getseedFarmer.data);
        setDataesticide(getposionFarmer.data);
        setLoadFarmer(getLoadFarmer.data);
        setpamentFarmerr(getPamentData.data);
        setReportData(response.data);
        console.log(response.data, "😍😍😍😍😍😍");
      } catch (err) {
        toast.error("خطا در دریافت گزارش");
        console.error(err, "❌❌❌");
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, []);

  const formatNumber = (num: number | undefined) => {
    if (num === undefined) return "-";
    const integerNum = Math.trunc(num); // یا Math.floor(num)
    return new Intl.NumberFormat("fa-IR").format(integerNum);
  };

  const dashboardItems = [
    {
      id: 11,
      title: "سود شما از کشاورزی",
      value: formatNumber(
        reportData?.your_farming_profit < 0
          ? 0
          : reportData?.your_farming_profit
      ),
    },
    {
      id: 12,
      title: "هزینه بذر",
      value: formatNumber(reportData?.total_seed_cost),
    },
    {
      id: 13,
      title: "هزینه سم",
      value: formatNumber(reportData?.total_pesticide_cost),
    },
    {
      id: 14,
      title: "جمع پرداختی‌ها به شما",
      value: formatNumber(reportData?.total_paid_to_you),
    },
    {
      id: 15,
      title: "تعداد بارهای تحویلی",
      value: formatNumber(reportData?.total_delivered_load),
    },
    {
      id: 16,
      title: "وزن کل بار های تحویلی",
      value: reportData?.total_weight_delivered
        ? `${formatNumber(reportData.total_weight_delivered)} `
        : "-",
      amount: "تن",
    },
    {
      id: 17,
      title: "مبلغ کل بارها",
      value: formatNumber(reportData?.total_pure_payable),
    },
    {
      id: 18,
      title: "کارمزد پیمانکار (یک درصد)",
      value: formatNumber(reportData?.one_percent_deduction),
    },
    {
      id: 19,
      title: "سهمیه شکر",
      value: formatNumber(reportData?.sugar_quota),
      amount: "کیلوگرم",
    },
    {
      id: 20,
      title: "سهمیه تفاله",
      value: formatNumber(reportData?.waste_quota),
      amount: "کیلوگرم",
    },
    {
      id: 21,
      title: "مانده تا تسویه",
      value: formatNumber(reportData?.remaining_to_settle),
      amount: "تومان",
    },
  ];

  return (
    <section className="bg-white dark:bg-transparent flex justify-start flex-col gap-4 items-center w-full p-1 transition-colors duration-200">
      <div className="rounded-md w-full flex flex-col justify-start items-center p-2 dark:bg-transparent">
        {loading ? (
          <div className="w-full flex justify-center items-center py-10">
            <p>در حال دریافت اطلاعات...</p>
          </div>
        ) : (
          <>
            <div className="w-full flex justify-center items-center gap-3 mb-4">
              <div className="bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded-full">
                <span className="dark:text-gray-200">
                  سال زراعی: {reportData?.crop_year_name || "-"}
                </span>
              </div>
            </div>
            <div className="w-full h-auto grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
              {dashboardItems.map((data) => (
                <BoxComponent
                  key={data.id}
                  title={data.title}
                  id={data.id}
                  value={data.value}
                  amount={data.amount}
                />
              ))}
            </div>
          </>
        )}
        {!loading && (
          <InvoiceWithInput
            dataSeed={DataSeed ? DataSeed : []}
            dataLoad={LoadFarmer}
            dataPayment={pamentFarmerr}
            dataPoison={Dataesticide}
            reportData={reportData}
            userInfo={UserFullName}
            userinfoData={userinfoData}
          />
        )}
      </div>
    </section>
  );
}

export default UserDashboard;
